import React from 'react';
import { Link } from 'react-router-dom';

import Layout from '../../components/layout/Layout';

export default class NotFoundPage extends React.Component {
  render() {
    return (
      <Layout history={this.props.history}>
        <h1>Page Not Found</h1>
        <Link to="/dashboard">Go to Dashboard</Link>
      </Layout>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/notfound/NotFoundPage.js